import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { api } from '@/api';

export function useInitializePreferences() {
  const queryClient = useQueryClient();

  const { isError, isIdle, isSuccess, mutate } =
    api.fct.userPreference.mutation.useInitUserPreferences(queryClient);

  useEffect(() => {
    if (isIdle) {
      mutate();
    }
  }, [isIdle, mutate]);

  return { isLoading: !isSuccess && !isError };
}
